import { createContext, useContext, useState, type ReactNode } from 'react';
import { OdooClient } from '@trace/connector';

interface OdooContextValue {
  client: OdooClient | null;
  setClient: (c: OdooClient | null) => void;
  logout: () => void;
}

const OdooContext = createContext<OdooContextValue | null>(null);

export function OdooProvider({ children }: { children: ReactNode }) {
  const [client, setClientState] = useState<OdooClient | null>(null);

  function setClient(c: OdooClient | null) {
    setClientState(c);
  }

  function logout() {
    setClientState(null);
  }

  return (
    <OdooContext.Provider value={{ client, setClient, logout }}>
      {children}
    </OdooContext.Provider>
  );
}

export function useOdoo() {
  const ctx = useContext(OdooContext);
  if (!ctx) throw new Error('useOdoo must be used inside OdooProvider');
  return ctx;
}
